import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable, combineLatest } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../common/models';
import { ListSearchCriteriaFacade } from '../../list-search-criteria/list-search-criteria.facade';
import { ListSearchCriteriaType } from '../../list-search-criteria';
import { ExportsListState, ExportsListStateModel } from './exports-list.state';
import { ExportsListDownloadFile, ExportsListInitialState, ExportsListLoad } from './exports-list.actions';
import { ExportItem } from '../../../models';
import { ExportsListSearchCriteria } from '../models/exports.model';
import { AuthFacade } from '../../auth';

@Injectable({ providedIn: 'root' })
export class ExportsListFacade implements LoadDataFacade, SetInitialStateFacade {
  listDto$: Observable<ExportsListStateModel> = this.store.select(ExportsListState.getState);
  items$: Observable<ExportItem[]> = this.store.select(ExportsListState.getItems);
  loaded$: Observable<boolean> = this.store.select(ExportsListState.getLoaded);

  constructor(
    private store: Store,
    private listSearchCriteriaFacade: ListSearchCriteriaFacade,
    public authFacade: AuthFacade,
  ) {}

  loadAll(): void {
    combineLatest([
      this.authFacade.timezone$,
      this.listSearchCriteriaFacade.getSearchCriteriaByListType(ListSearchCriteriaType.Exports),
    ]).subscribe(([timezone, filter]: [string, ExportsListSearchCriteria]) => {
      this.store.dispatch(new ExportsListLoad({ timezone, filter }));
    });
  }

  downloadExportsFile(documentId: string): void {
    this.store.dispatch(new ExportsListDownloadFile(documentId));
  }

  setInitialState(): void {
    this.store.dispatch(new ExportsListInitialState());
  }
}
